import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../services/api"; // Import Axios instance
import "./BlogView.css";

const BlogView = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch the blog by ID
  const fetchBlog = async () => {
    try {
      const response = await api.get(`/blogs/${id}`);
      setBlog(response.data);
    } catch (error) {
      console.error("Error fetching blog:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlog();
  }, [id]);

  if (loading) {
    return <p className="loading">Loading blog...</p>;
  }

  return (
    <div className="blog-container">
      <div className="blog-overlayer">
        <div className="blog-view">
          <h1 className="blog-title">{blog?.title}</h1>
          <p className="blog-date">
            {new Date(blog?.createdAt).toLocaleString()}
          </p>

          {/* Render content dangerously as HTML */}
          <div
            className="blog-content"
            dangerouslySetInnerHTML={{ __html: blog?.content }}
          />
        </div>
      </div>
    </div>
  );
};

export default BlogView;
